module.exports = __webpack_public_path__ + "6bc7f982228fd550ec4464aa270e148b.png";